export default __webpack_public_path__ + "static/media/no-meal.01aba48d.png";